/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Cta_TitleInputs */

const en_svc_rag_cta_title = /** @type {(inputs: Svc_Rag_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring a question your team answers every week.`)
};

const lv_svc_rag_cta_title = /** @type {(inputs: Svc_Rag_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atnesiet jautājumu, uz ko komanda atbild katru nedēļu.`)
};

/**
* | output |
* | --- |
* | "Bring a question your team answers every week." |
*
* @param {Svc_Rag_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_cta_title = /** @type {((inputs?: Svc_Rag_Cta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Cta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_cta_title(inputs)
	return en_svc_rag_cta_title(inputs)
});